import SHIPMENT_EVENT, { SHIPMENT_EVENTS_LABELS } from '../../../shipment_manager/api/shipment-events/enums/shipment-event-types';
import { LOCATION_TYPE } from './api/enums/location-types';
import { LOCATION_ROLE } from './api/enums/location-roles';
import { IGNORE_EVENT_TYPES } from './api/enums/ignore-events-types';

export const LOCATION_TYPE_LABELS: { [key in LOCATION_TYPE]: string } = {
  [LOCATION_TYPE.STANDARD]: 'locationType_location',
  [LOCATION_TYPE.HOT_ZONE]: 'locationType_hotZone',
  [LOCATION_TYPE.SAFE_ZONE]: 'locationType_safeZone',
  [LOCATION_TYPE.DANGER_ZONE]: 'locationType_dangerZone',
  [LOCATION_TYPE.AIRPORT]: 'locationType_airport',
  [LOCATION_TYPE.SEAPORT]: 'locationType_seaport',
  [LOCATION_TYPE.OPEN_MIC_ZONE]: 'locationType_openMicZone',
  [LOCATION_TYPE.LOW_COVERAGE_ZONE]: 'locationType_lowCoverageZone',
  [LOCATION_TYPE.CUSTOMER]: 'locationCustomer',
  [LOCATION_TYPE.DEPOT]: 'locationDepot',
  [LOCATION_TYPE.DISTRIBUTION_CENTER]: 'locationDistributionCentre',
  [LOCATION_TYPE.FULFILLMENT_CENTER]: 'locationFulfillmentnCenter',
  [LOCATION_TYPE.OUTSIDE_STORAGE]: 'locationOutsideStorage',
  [LOCATION_TYPE.VENDOR]: 'locationVendor',
  [LOCATION_TYPE.EBOL]: 'locationType_ebol',
};

export const LOCATION_ROLE_LABELS: { [key in LOCATION_ROLE]: string } = {
  [LOCATION_ROLE.ORIGIN]: 'OriginLocation',
  [LOCATION_ROLE.DESTINATION]: 'DestinationLocation',
  [LOCATION_ROLE.PICKUP]: 'PickupLocation',
  [LOCATION_ROLE.DELIVERY]: 'DeliveryLocation',
  [LOCATION_ROLE.STOP]: 'PlannedStopLocation',
  [LOCATION_ROLE.CORRECTION]: 'roadCorrectionLocation',
  [LOCATION_ROLE.FULFILLMENT]: 'fulfillmentLocation',
  [LOCATION_ROLE.VENUE]: 'venue',
};

export const IGNORE_EVENT_TYPES_LABELS: { [key in IGNORE_EVENT_TYPES]: string } = {
  [IGNORE_EVENT_TYPES.LIGHT]: SHIPMENT_EVENTS_LABELS[SHIPMENT_EVENT.LIGHT_SHIPMENT_EVENT],
  [IGNORE_EVENT_TYPES.SEAL_OPEN]: SHIPMENT_EVENTS_LABELS[SHIPMENT_EVENT.SEAL_OPEN],
  [IGNORE_EVENT_TYPES.DOOR_OPEN]: SHIPMENT_EVENTS_LABELS[SHIPMENT_EVENT.DOOR_OPEN_SHIPMENT_EVENT],
  [IGNORE_EVENT_TYPES.LIGHT_STOP_COMPOUND]: SHIPMENT_EVENTS_LABELS[SHIPMENT_EVENT.LIGHT_AND_STOP_COMPOUND],
};

export const ZONE_LOCATION_TYPES = [
  LOCATION_TYPE.DANGER_ZONE,
  LOCATION_TYPE.HOT_ZONE,
  LOCATION_TYPE.OPEN_MIC_ZONE,
  LOCATION_TYPE.SAFE_ZONE,
  LOCATION_TYPE.LOW_COVERAGE_ZONE
];

export const GROUND_LOCATION_TYPES = [
  LOCATION_TYPE.STANDARD,
  LOCATION_TYPE.CUSTOMER,
  LOCATION_TYPE.DEPOT,
  LOCATION_TYPE.DISTRIBUTION_CENTER,
  LOCATION_TYPE.FULFILLMENT_CENTER,
  LOCATION_TYPE.OUTSIDE_STORAGE,
  LOCATION_TYPE.VENDOR,
  LOCATION_TYPE.EBOL,
];

export const GLOBAL_ZONE_LOCATION_TYPES = [
  LOCATION_TYPE.OPEN_MIC_ZONE,
  LOCATION_TYPE.DANGER_ZONE,
  LOCATION_TYPE.LOW_COVERAGE_ZONE,
];

export const IGNORE_EVENTS_ZONES = [LOCATION_TYPE.SAFE_ZONE];

export const INPUT_LOCATION_TYPES = [
  LOCATION_TYPE.AIRPORT,
  LOCATION_TYPE.CUSTOMER,
  LOCATION_TYPE.DEPOT,
  LOCATION_TYPE.DISTRIBUTION_CENTER,
  LOCATION_TYPE.FULFILLMENT_CENTER,
  LOCATION_TYPE.STANDARD,
  LOCATION_TYPE.OUTSIDE_STORAGE,
  LOCATION_TYPE.SEAPORT,
  LOCATION_TYPE.VENDOR,
  LOCATION_TYPE.EBOL,
  ...ZONE_LOCATION_TYPES
];

export const CUSTOM_LOCATION_JSON_FORMAT = 'custom_location_geo_json';